import { Box, Stack, Text } from '@ltvco/refresh-lib/theme';
import { Gavel } from '@mui/icons-material';

import { OpinionTypeText } from 'components/ChatBV/constants';
import { OpinionResult } from 'routes/Dashboard/CourtCases/v2/types';

import { TeaserField } from '../MessageTeaser';
import { ReportChatCard } from '../ReportChatCard';

interface CourtOpinionsCardProps {
  item: OpinionResult;
  index: number;
  clickAction?: () => void;
}
export const CourtOpinionsCard = ({
  item,
  index,
  clickAction,
}: CourtOpinionsCardProps) => {
  const simpleFields = [
    {
      label: 'Docket',
      value: item.docketNumber,
    },
    {
      label: 'Court',
      value: item.court,
    },
    {
      label: 'Citations',
      value: Array.isArray(item.citation) ? item.citation.join(', ') : '',
    },
    {
      label: 'Nature of Suit',
      value: item.suitNature,
    },
    {
      label: 'Judge',
      value: item.judge,
    },
  ];

  return (
    <ReportChatCard
      key={`court-opinions-card-${index}`}
      title={item.caseName || ''}
      reportType="court-opinions"
      icon={<Gavel color="primary" fontSize="small" />}
      clickAction={clickAction}
      description={
        <Stack spacing={0.5}>
          <Text variant="body2" color="text.primary" sx={{ mb: 0.5 }}>
            <Text component="span" sx={{ fontWeight: 600 }}>
              Filed:
            </Text>{' '}
            {new Date(item.dateFiled).toLocaleDateString()}
            {item.status && ` | `}
            <Text component="span" sx={{ fontWeight: 600 }}>
              Status:
            </Text>{' '}
            {item.status}
          </Text>

          {simpleFields.map((field, fieldIndex) =>
            field.value ? (
              <TeaserField
                key={fieldIndex}
                label={field.label}
                value={field.value}
              />
            ) : null
          )}
          {(item.opinions ?? []).map((opinion, opinionIndex) => (
            <Box key={`opinion-${index}-${opinionIndex}`}>
              <Text component="span" sx={{ fontWeight: 600 }}>
                {OpinionTypeText[opinion.type]}
              </Text>
              <Text variant="body2" color="text.primary" sx={{ mb: 0.5 }}>
                {opinion.snippet}
              </Text>
            </Box>
          ))}
        </Stack>
      }
      disabled={false}
    />
  );
};
